import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CONSTANT from "../../../constant";
import Header from "../../../component/common/Header";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { addDak, generateCode } from "../../../actions/DakManagement";
import { toast } from "react-toastify";
import { getCookie } from "../../../utils";
import { TextField } from "@fluentui/react";

function DakManagement() {
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const user = getCookie(CONSTANT.cookie.userDetail);
  const [to, setTo] = useState("");
  const [description, setDescription] = useState("");
  const [mailCode, setMailCode] = useState(null)
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    generateMailCode()
  }, [])

  function onUserInput(field, value) {
    setShowErrorAlert(false);
   
     if (field === "to") {
      setTo(value);
    }
     
    if (field === "description") {
      setDescription(value);
    } 

  }

  async function generateMailCode() {
    setShowLoader(true)
     
    try {
      const {result} = await generateCode('outbound')
      const mailCode = `${result.type}/${result.id}`
      setMailCode(mailCode)
    } catch(e) {
      console.log(e)
    } 
    setShowLoader(false)
  
   }

  async function onSubmit() {
    
    setShowLoader(true);

    const payload = {
      to,
      description,
      type: "outbound",
      mailCode,
    };
     
    try {
      if (Object.values(payload).some((item) => !item.length)) {
        setShowErrorAlert(true);
        setShowLoader(false);
        return;
      }
       
      await addDak(payload);
      clearFields();
      toast("Dak Created");
      generateMailCode()
    } catch (e) {
      console.log(e, "eee");
    }
    setShowLoader(false);
  }

  function clearFields() {
    setTo("");
    setDescription("");
  }

  return (
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-md-2 px-0">
          <Header />
        </div> */}
        <div className="col-md-12 mt-3">
          <div className="card homedob p-4 mb-4">
          <div
            className="col-md-12"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <h1 className="page-title">DAK Management - Outbound</h1>
            <div>
              <Link
                to={CONSTANT.component.dakManagementList.url}
                className="btn btn-block btn-sm submit-button p-2"
              >
                <i className="fa fa-list mr-2" />
                Dak List
              </Link>
            </div>
          </div>
          <div className="col-md-12 p-3">
            {showLoader ? (
              <div>
                <p>Please Wait...</p>
              </div>
            ) : (
              <form onSubmit={(e) => e.preventDefault()} className="card p-3">
                <div className="" style={{display: 'flex', justifyContent: 'space-between'}}>
                  <p>
                    From:{" "}
                    <span style={{ fontWeight: "bold" }}>{user.name}</span>
                  </p>
                  <p style={{ fontWeight: "bold" }}>Code: {mailCode}</p>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    label="To"
                    required
                    onChange={(e) => onUserInput("to", e.target.value)}
                    value={to}
                  />
                </div>
                <div
                  className="mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <TextField
                    label="Description"
                    multiline
                    required
                    onChange={(e) => onUserInput("description", e.target.value)}
                    value={description}
                  />
                </div>
                <div className="col-md-12 mt-3">
                  {showErrorAlert && (
                    <MessageBar
                      delayedRender={false}
                      messageBarType={MessageBarType.error}
                    >
                      Please fill all fields
                    </MessageBar>
                  )}
                </div>
                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <PrimaryButton text="Submit" onClick={onSubmit} />
                </div>
              </form>
            )}
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DakManagement;
